import { Form } from "antd";

export const FormUi = ({ initialValues = {}, handleSubmit, ...props }) => {
  return (
    <Form
      scrollToFirstError
      initialValues={initialValues}
      onFinish={handleSubmit}
      className="ui-form"
      {...props}
    />
  );
};
